import { isAxiosError } from 'axios';
import { type ServerError } from 'types/augmentations/react-query';

/**
 * Extract a BE error's human-readable `detail` message.
 *
 * @param error - The error thrown by the request (typically an AxiosError).
 * @returns The trimmed `detail` string, or '' when the error isn't an Axios
 *   error, carries no `detail`, or the detail isn't a string (e.g. a FastAPI 422
 *   returns a structured array). Callers fall back to their own copy on ''.
 */
export const getServerErrorDetail = (error: unknown): string => {
  const detail = isAxiosError(error)
    ? (error as ServerError).response?.data?.detail
    : undefined;

  return typeof detail === 'string' ? detail.trim() : '';
};
